import React from "react";
import {
  CaseStudy,
  HeroSection,
  NewsSection,
  OurProduct,
  QuotePage,
  Testimonial,
  BlogSection,
  NodeFlowPreview,
} from "./Component";
import { useGetHomeNewsData } from "../../hooks/useRQHome";
import { useGetHomeBlogData } from "../../hooks/useRQHome";
import { useGetOurproductData } from "../../hooks/useRQOurproduct";
import { useGetFeaturesData } from "../../hooks/useRQFeatures";
import { useGetTestimonialData } from "../../hooks/useRQTestimonial";
import { LoadingSpinner } from "../../common/components";

const HomePage = () => {
  let home_data = [];
  let home_data1 = [];
  let ourproduct_data = [];
  let features_data = [];
  let testimonial_data = [];

  /**
   * Fetch data using custom hooks
   */
  const { isLoading: homeNewsLoading, data: general_data } =
    useGetHomeNewsData();
  if (!homeNewsLoading) {
    home_data = general_data?.data || [];
  }

  const { isLoading: homeBlogLoading, data: general1_data } =
    useGetHomeBlogData();
  if (!homeBlogLoading) {
    home_data1 = general1_data?.data || [];
  }

  const { isLoading: productLoading, data: product_data } =
    useGetOurproductData();
  if (!productLoading) {
    ourproduct_data = product_data?.data || [];
  }

  const { isLoading: featuresLoading, data: feature_data } =
    useGetFeaturesData();
  if (!featuresLoading) {
    features_data = feature_data?.data || [];
  }

  const { isLoading: testimonialLoading, data: testimonials_data } =
    useGetTestimonialData();
  if (!testimonialLoading) {
    testimonial_data = testimonials_data?.data || [];
  }

  // Check if any data is still loading
  const isLoading =
    homeNewsLoading ||
    homeBlogLoading ||
    productLoading ||
    featuresLoading ||
    testimonialLoading;

  // Render
  return (
    <div>
      {isLoading ? (
        <LoadingSpinner /> // Show loader when data is loading
      ) : (
        <>
          {features_data.active_features && (
            <HeroSection feature_data={features_data.active_features} />
          )}
          {home_data.data1 && <NewsSection news_data={home_data.data1} />}
          {ourproduct_data.active_ourproduct && (
            <OurProduct product_data={ourproduct_data.active_ourproduct} />
          )}
          <NodeFlowPreview />
          {testimonial_data.active_testimonial && (
            <Testimonial
              testimonials_data={testimonial_data.active_testimonial}
            />
          )}
          <CaseStudy />
          {home_data1.data1 && <BlogSection blog_data={home_data1.data1} />}
          <QuotePage />
        </>
      )}
    </div>
  );
};

export default HomePage;
